// This file is autogenerated. Any changes will be overwritten.
export const name = 'galaxy';

export const Component = () => (
  <>
    <path d='m4.80000105 11.8c.6627417 0 1.2.5372583 1.2 1.2s-.5372583 1.2-1.2 1.2-1.2-.5372583-1.2-1.2c.04774248-.6419276.55807244-1.1522575 1.2-1.2m0-1.6c-1.5463973 0-2.80000053 1.2536027-2.80000053 2.8-.00092921 1.5633724 1.2375576 2.8460909 2.80000053 2.9.76912782 0 1.50675416-.3055348 2.05060966-.8493903s.84939091-1.2814819.84939091-2.0506097c.00048445-.7602615-.30820203-1.4880368-.85513537-2.0161104-.54693333-.5280736-1.28508859-.811042-2.0448652-.7838896z' />
    <path d='m17.66 3.3-1.16 3.2-3.3 1.16c-.2204773.08758911-.2640869.56244263 0 .67l3.300001 1.17 1.159999 3.3c.1.3.5430182.3.67 0l1.17-3.3c1.9814718-.70080811 3.0814718-1.09080811 3.3-1.17.3277924-.11878784.2046539-.59780701 0-.67-.136436-.04812866-1.236436-.43479533-3.3-1.16l-1.17-3.2c-.1871928-.41454773-.5224791-.37723999-.67 0z' />
    <circle cx='15.5' cy='20.5' r='1.5' />
  </>
);

export const viewBox = '0 0 25 25';
